export { SlidingTabs } from './SlidingTabs';
export type { SlidingTabItem, SlidingTabsVariant } from './SlidingTabs';
